import { CSSObject } from "styled-components";
import { Unit } from "../../../../../types/globals";

const cssObjectForSecondaryState = (
	colorHex: string | undefined,
	borderSize?: Unit
): CSSObject => {
	return {
		backgroundColor: "transparent",
		border: borderSize ? `${borderSize} solid ${colorHex}` : undefined,
		borderColor: !borderSize ? colorHex : undefined,
		color: colorHex,
		".Typography": {
			color: colorHex,
		},
		".Icon svg": {
			fill: colorHex,
		},
	};
};

export default cssObjectForSecondaryState;
